/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractResourceService } from '@irian-ro/abstract-resource';
import {EnvironmentService} from "@irian-ro/util-environment";
import { Observable } from 'rxjs';
import { TermsAndConditionsAgreementDtoModel, TermsAndConditionsAgreementVoModel } from '@well/domain';

@Injectable({
  providedIn: 'root',
})
export class TermsAndConditionsAgreementResourceService extends AbstractResourceService<
  TermsAndConditionsAgreementVoModel,
  TermsAndConditionsAgreementDtoModel,
  undefined,
  undefined
> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(httpClient, environmentService.getEnvironmentProperty('termsAndConditionsAgreementUrl'), undefined, undefined);
  }

  getAgreementForUser(userUuid: string, documentVersion: string) {
    return this.httpClient?.get(
      `${this.url}/user/${userUuid}/terms-and-conditions/version/${documentVersion}`
    ) as Observable<TermsAndConditionsAgreementVoModel>;
  }

  save(
    termsAndConditionsAgreementDTO: TermsAndConditionsAgreementDtoModel
  ): Observable<TermsAndConditionsAgreementVoModel> {
    return <Observable<TermsAndConditionsAgreementVoModel>>this.httpClient?.post(`${this.url}`, termsAndConditionsAgreementDTO, { headers: this.headers });
  }
}
